import { useAuth0 } from "@auth0/auth0-react";

export const useAuthService = () => {
  const {
    loginWithRedirect,
    logout,
    getAccessTokenSilently,
    user,
    isAuthenticated,
  } = useAuth0();

  return {
    login: async () => {
      await loginWithRedirect({
        authorizationParams: {
          audience: process.env.REACT_APP_AUTH0_AUDIENCE,
          scope: "openid profile email offline_access",
        },
      });

      // ✅ Ensure user is set
      if (user) {
        localStorage.setItem("user", JSON.stringify(user));
      }
    },

    logout: () => {
      // Preserve cookie preferences and banner display
      const cookiePreferences = localStorage.getItem('cookiePreferences');
      const displayCookieBanner = localStorage.getItem('displayCookieBanner');
      
      // Clear all localStorage
      localStorage.clear();
      
      // Restore cookie-related items
      if (cookiePreferences) {
        localStorage.setItem('cookiePreferences', cookiePreferences);
      }
      if (displayCookieBanner) {
        localStorage.setItem('displayCookieBanner', displayCookieBanner);
      }
      
      logout({ logoutParams: { returnTo: window.location.origin } });
    },

    getToken: async () => {
      try {
        return await getAccessTokenSilently();
      } catch (error) {
        console.error("Error getting token:", error);
        return null;
      }
    },

    isAuthenticated,
    user,
  };
};
